<template>
	<div>
		<nav id="nav" class="navbar navbar-expand-lg navbar-dark p-md-2 px-2" v-bind:class="{ darker: isDarker }">
			<a class="navbar-brand d-md-flex d-none ms-4 p-0" href="/">
				<img src="../assets/img/csoda.png" draggable="false" class="img-fluid deer-flip">
				<div class="mx-2 text-center navbar-brand__title">
					<p class="m-0">Csodaszarvas</p>
					<p class="m-0">Íjászbarlang</p>
				</div>
				<img src="../assets/img/csoda.png" draggable="false" class="img-fluid deer">
			</a>
			<a class="navbar-brand d-flex d-md-none p-0" href="/">
				<img src="../assets/img/csoda.png" draggable="false" class="img-fluid deer">
			</a>
			<div class="d-block d-md-none mobile-flag position-absolute">
				<a class="nav-link position-relative p-0" v-on:click="changeLocale">
        			<img v-bind:src="img_link" width="35">
        		</a>
			</div>
			<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" :class="{ 'collapsed': toggledNav }">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse justify-content-md-center" id="navbarNavDropdown" :class="{ 'collapse': toggledNav }">
				<ul class="navbar-nav ms-auto">
					<!--<router-link class="nav-item py-3 px-4" to="/" tag="li" active-class="active" exact @click="toggledNav = !toggledNav">
						<a class="nav-link position-relative p-0">{{ $t("navbar.home") }}</a>
					</router-link>-->
					<router-link class="nav-item py-md-3 p-2 px-4 text-uppercase" to="/about" tag="li" active-class="active" exact @click="toggledNav = !toggledNav">
						<a class="nav-link position-relative p-0">{{ $t("navbar.about") }}</a>
					</router-link>
					<li class="nav-item py-md-3 p-2 px-4 text-uppercase">
						<a class="nav-link position-relative p-0" href="https://csodaszarvas-ijaszbarlang.salonic.hu/">{{ $t("navbar.booking") }}</a>
					</li>
					<router-link class="nav-item py-md-3 p-2 px-4 text-uppercase" :to="lang == 'hu' ? '/ijaszpalya':'/archery-range'" tag="li" active-class="active" exact @click="toggledNav = !toggledNav">
						<a class="nav-link position-relative p-0">{{ $t("navbar.field") }}</a>
					</router-link>
					<!--<li class="nav-item py-3 px-4 position-relative dropdown">
						<a class="nav-link position-relative dropdown-toggle p-0" data-toggle="dropdown">{{ $t("navbar.products") }}</a>
		                <div class="dropdown-menu">
		                	<router-link class="dropdown-item" :to="lang == 'hu' ? '/termekeink/ijak' : '/products/bows'" v-on:click.native="sendData('ijak', 'bows', 'Íjak', 'Bows')">
		                		{{ $t("navbar.bows") }}
		                	</router-link>
		                    <router-link class="dropdown-item" :to="lang == 'hu' ? '/termekeink/nyilvesszok' : '/products/arrows'" v-on:click.native="sendData('nyilvesszok','arrows', 'Nyílvesszők','Arrows')">
		                    	{{ $t("navbar.arrows") }}
		                    </router-link>
		                    <router-link class="dropdown-item" :to="lang == 'hu' ? '/termekeink/vesszofogok' : '/products/targets'" v-on:click.native="sendData('vesszofogok','targets', 'Vesszőfogók','Targets')">
								{{ $t("navbar.targets") }}
		                    </router-link>
		                    <router-link class="dropdown-item" :to="lang == 'hu' ? '/termekeink/tegezek' : '/products/quivers'" v-on:click.native="sendData('tegezek','quivers','Tegezek','Quivers')">
		                    	{{ $t("navbar.quivers") }}
		                    </router-link>
		                    <router-link class="dropdown-item" :to="lang == 'hu' ? '/termekeink/vedofelszerelesek' : '/products/protective-equipment'" v-on:click.native="sendData('vedofelszerelesek','protective-equipment', 'Védőfelszerelés','Protective Equipment')">
		                    	{{ $t("navbar.protective") }}
		                    </router-link>
		                    <router-link class="dropdown-item" :to="lang == 'hu' ? '/termekeink/egyebek' : '/products/other'" v-on:click.native="sendData('egyebek','other', 'Egyéb','Other')">
		                    	{{ $t("navbar.other") }}
		                    </router-link>
		                </div>
					</li>-->
					<router-link class="nav-item py-md-3 p-2 px-4 text-uppercase" :to="lang == 'hu' ? '/hirek':'/news'" tag="li" active-class="active" exact>
						<a class="nav-link position-relative p-0">{{ $t("navbar.news") }}</a>
					</router-link>
					<router-link class="nav-item py-md-3 p-2 px-4 text-uppercase" :to="lang == 'hu' ? '/egyesulet':'/association'" tag="li" active-class="active" exact>
						<a class="nav-link position-relative p-0">{{ $t("navbar.club") }}</a>
					</router-link>
					<router-link class="nav-item py-md-3 p-2 px-4 text-uppercase" :to="lang == 'hu' ? '/kapcsolat':'/contact'" tag="li" active-class="active" exact>
						<a class="nav-link position-relative p-0">{{ $t("navbar.contact") }}</a>
					</router-link>
					<li class="nav-item p-3 d-none d-md-block">
		        		<a class="nav-link position-relative p-0" v-on:click="changeLocale">
		        			<img v-bind:src="img_link" width="35">
		        		</a>
		      		</li>
				</ul>
			</div>
		</nav>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";
	
	export default {
		data() {
	        return {
	            lang: '',
	            img_link: "/dist/en.png",
	            toggledNav: false,
	            isDarker: true
	        };
	    },
		created(){
			this.lang = this.$i18n.locale;

			window.addEventListener("scroll", this.fixedNavbar);
		},
		watch: {
		    '$route' () {
		      	this.toggledNav = !this.toggledNav;

		      	if (this.$route.path !== '/') {
			        this.isDarker = false
			    }else {
			        this.isDarker = true
			    }
		    }
		},
		methods: {
			fixedNavbar: function(){
				let navbar = document.getElementById("nav");
				if(window.location.href === 'http://localhost:8081/' || window.location.href === 'https://ijaszat.eu/'){
					navbar.classList.add('fixed-top');
					if(document.documentElement.scrollTop > 700){
		              	navbar.classList.add('solid');
			        }else{
			            navbar.classList.remove('solid');
			        }
				}else{
					navbar.classList.remove('fixed-top', 'solid');
				}
			},
			sendData: function(typeHU, typeEN, titleHU, titleEN){
				Bus.$emit("type", typeHU, typeEN, titleHU, titleEN);
			},
			changeLocale: function() {
				if(this.lang == "hu"){
	       			this.lang = "en";
	       			this.img_link = "/dist/hu.png";
	       		}else{
	       			this.lang = "hu";
	       			this.img_link = "/dist/en.png";
	       		}
	       		this.$i18n.locale = this.lang;
	       		Bus.$emit("lang", this.lang);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/Navbar.vue